import type { StudySession, StudySessionProgress, TomorrowCards } from '../../model/domain/StudySession';
import type { StudySessionTO } from '../to/StudySessionTO';

const toDomain = (to: StudySessionTO): StudySession => ({
  id: to.id,
  startedOn: to.startedOn,
  updatedOn: to.updatedOn,
  hasAssignments: to.hasAssignments,
  progress: to.progress as StudySessionProgress,
  tomorrow: to.tomorrow as TomorrowCards,
});

export default {
  toDomain,
};
